import {
  Button,
  Input,
  Select,
  Divider,
  Dropdown,
  Menu,
  DatePicker,
} from 'antd'
import React, { useEffect, useState } from 'react'
import {
  SearchOutlined,
  FileExcelOutlined,
  FilePdfOutlined,
} from '@ant-design/icons'
import {
  AGE_SEARCH_TYPE,
  SEARCH_QUERY_TYPE,
  COUNTRY_TYPE,
  GENDER_TYPE,
  PHONE_MODEL,
  PROVIDER_COUNTRY,
  gameUsageReportFilters,
  GROUP_QUERY_TYPE,
  groupingFilters,
  treasureHunterReportFilters,
  userType,
  allUserTypeOptions,
} from 'src/constants'
import { getListOfGames, searchGameReport } from 'src/api/reports'
import { getByCategories, getGamesCategory } from 'src/api/game'
import { useCategoryMap } from 'src/hooks/GamesCategoryContext'
import { UserNameAutoComplete } from 'src/components/Search/UserNameSearch'
import ProviderCountrySelect from 'src/components/Input/ProviderCountrySelect'

interface TreasureHunterReportSearchProps {
  appendSearchForm: (obj: any) => void
  submitSearchForm: () => void
}

const TreasureHunterReportSearch: React.FC<TreasureHunterReportSearchProps> = ({
  appendSearchForm,
  submitSearchForm,
}) => {
  const [loading, setLoading] = useState(false)
  const [searchType, setSearchType] = useState('Between')
  const [minAge, setMinAge] = useState('')
  const [maxAge, setMaxAge] = useState('')
  const [country, setCountry] = useState('')
  const [searchQueryType, setSearchQueryType] = useState([])
  const [gender, setGender] = useState('Male')
  const [deviceType, setdeviceType] = useState('')
  const [clientName, setClientName] = useState('')
  const [buttonAction, setButtonAction] = useState('Select')
  const [providerCountry, setProviderCountry] = useState('')
  const [userName, setUserName] = useState('')
  const [gameId, setGameId] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [listOfGames, setListOfGames] = useState([])
  const [gameCategory, setGameCategory] = useState('')
  const [listOfCategories, setListOfCategories] = useState([])
 const [selectedFilterValue, setSelectedFilterValue] = useState('ALL');
  const { categoryMap, filterGamesByType, findCategoriesForGame } = useCategoryMap()
  const handlePdfClick = () => {
    appendSearchForm({ buttonAction: 'Generate Pdf' })
    submitSearchForm()
  }

  const handleCsvClick = () => {
    appendSearchForm({ buttonAction: 'Generate Csv' })
    submitSearchForm()
  }
  const handleSearchClick = () => {
    appendSearchForm({ buttonAction: ' ' })
    submitSearchForm()
    setButtonAction(null)
  }

  const handleSearchTypeChange = (value: string) => {
    setSearchType(value)
    setMinAge('')
    setMaxAge('')
    setProviderCountry('')
    setUserName('')
    setGameId('')
    setStartDate('')
    setEndDate('')
    setGameCategory('')
  }
  const handleSearchQueryTypeChange = React.useCallback((opts: any[]) => {
    setSearchQueryType(opts)

    appendSearchForm({ searchQueryType })
  }, [])
  const filterGameOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }

  const filterCountryOption = (inputValue, option) => {
    return option.children.toLowerCase().includes(inputValue.toLowerCase())
  }
  const handleSearchQueryTypeDeselect = React.useCallback(
    (deselectedOption: any) => {
      const updatedOptions = searchQueryType.filter(
        (option) => option !== deselectedOption
      )

      switch (deselectedOption) {
        case 'By Age':
          appendSearchForm({ maxAge: '', minAge: '' })
          break
        case 'By Country':
          appendSearchForm({ country: '' })
          break
        case 'By Gender':
          appendSearchForm({ gender: '' })
          break
        case 'By Device Type':
          appendSearchForm({ deviceType: '' })
          break
        case 'By Provider':
          appendSearchForm({ providerCountry: '' })
          break
        case 'By User Name':
          appendSearchForm({ userName: '' })
          break
        case 'By Game':
          appendSearchForm({ gameId: '' })
          break
        case 'By Event Date':
          appendSearchForm({ startDate: '', endDate: '' })
          break
        case 'By Game Category':
          appendSearchForm({ gameCategory: '' })
          break
        default:
          break
      }

      appendSearchForm(updatedOptions)
      submitSearchForm()
    },
    [searchQueryType]
  )

  const handleSearchQueryTypeClear = React.useCallback(() => {
    appendSearchForm({
      searchQueryType: '',
      country: '',
      deviceType: '',
      gender: '',
      maxAge: '',
      minAge: '',
      buttonAction: '',
      providerCountry: '',
      userName: '',
      gameId: '',
      startDate: '',
      endDate: '',
      gameCategory:'',
    })

    submitSearchForm()
  }, [])
  const handleSearchTypeClear = React.useCallback(() => {
    appendSearchForm({
      maxAge: '',
      minAge: '',
      searchType: '',
      providerCountry: '',
      userName: '',
      gameId: '',
      startDate: '',
      endDate: '',
      gameCategory:'',
    })

    submitSearchForm()
  }, [])
  useEffect(() => {
    appendSearchForm({ maxAge: '' })
    appendSearchForm({ minAge: '' })
    appendSearchForm({ searchType })
    appendSearchForm({ providerCountry: '' })
    appendSearchForm({ userName: '' })
    appendSearchForm({ gameId: '' })
    appendSearchForm({ startDate: '' })
    appendSearchForm({ endDate: '' })
    appendSearchForm({ gameCategory: '' })
  }, [searchType])

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const data = await getListOfGames()
        if (data) {
          setListOfGames(data)
        }
      } catch (error) {
        console.error('Error fetching games:', error)
      }
    }

    fetchGames()
    const fetchGameCategories = async () => {
      try{
        const data = await getGamesCategory()
        if (data){
          setListOfCategories(data)
        }
      } catch (error){
        console.error('Error fetching game category:', error)
      }
    }
    fetchGameCategories()
   
    
  }, [])
  const handleGroupByClear = React.useCallback(() => {
    appendSearchForm({
     groupBy:''
    })

    submitSearchForm()
  }, [])
  const filterGameCategoryOption = (inputValue, option) => {
    return option.label.toLowerCase().includes(inputValue.toLowerCase())
  }
   const handleFilterChange = (value) => {
        setSelectedFilterValue(value);
        let userTypesForSearch;
    
        if (value === 'ALL') {
         
          userTypesForSearch = userType.map(option => option.value);
        } else {
          
          userTypesForSearch = [value];
        }
    
        appendSearchForm({ userAccessType: userTypesForSearch });
        
      };
       const handleCountryChange = (countriesList: string[]) => {
    appendSearchForm({ providers: countriesList });
  };
  return (
    <>
      <Select
        placeholder="Select Search Criteria"
        value={searchQueryType}
        mode="multiple"
        allowClear
        onChange={handleSearchQueryTypeChange}
        onClear={handleSearchQueryTypeClear}
        onDeselect={handleSearchQueryTypeDeselect}
        className="search-input"
      >
        {SEARCH_QUERY_TYPE.filter((option) =>
          treasureHunterReportFilters.includes(option)
        ).map((val) => (
          <Select.Option value={val} key={val}>
            {val}
          </Select.Option>
        ))}
      </Select>
      <Select
  placeholder="Select Grouping Criteria"
  allowClear
  onChange={(value) => appendSearchForm({ groupBy: value })}
  onClear={handleGroupByClear}
  className="search-input"
>
  {GROUP_QUERY_TYPE.filter((option) =>
    groupingFilters.includes(option.label)
  ).map((option) => (
    <Select.Option value={option.value} key={option.value}>
      {option.label}
    </Select.Option>
  ))}
</Select>
      <Divider />
      {searchQueryType.includes('By User Name') && (
        <>
          <UserNameAutoComplete  appendSearchForm={appendSearchForm} />
        </>
      )}
     
       

      {searchQueryType.includes('By Age') && (
        <Select
          placeholder="Select Range"
          value={searchType}
          allowClear
          onChange={handleSearchTypeChange}
          onClear={handleSearchTypeClear}
          className="search-input"
        >
          {AGE_SEARCH_TYPE.map((val) => (
            <Select.Option value={val} key={val}>
              {val}
            </Select.Option>
          ))}
        </Select>
      )}
      {searchQueryType.includes('By Age') && searchType === 'Between' && (
        <>
          <Input
            type="number"
            placeholder="Minimum Age"
            allowClear
            onChange={(e) => appendSearchForm({ minAge: e.target.value })}
            className="search-input"
          />

          <Input
            type="number"
            placeholder="Maxiumum Age"
            allowClear
            onChange={(e) => appendSearchForm({ maxAge: e.target.value })}
            className="search-input"
          />
        </>
      )}
      {searchQueryType.includes('By Age') && searchType === 'Greater Than' && (
        <Input
          type="number"
          placeholder="Age Greater Than"
          onChange={(e) => appendSearchForm({ minAge: e.target.value })}
          className="search-input"
        />
      )}
      {searchQueryType.includes('By Age') && searchType === 'Less Than' && (
        <Input
          type="number"
          placeholder="Age Less Than"
          onChange={(e) => appendSearchForm({ maxAge: e.target.value })}
          className="search-input"
        />
      )}
      {searchQueryType.includes('By Country') && (
        <Select
          placeholder="Select Country"
          onChange={(value) => appendSearchForm({ country: value })}
          filterOption={filterCountryOption}
          allowClear
          onClear={() => appendSearchForm({ country: '' })}
          className="search-input"
          showSearch
        >
          {COUNTRY_TYPE.map((val) => (
            <Select.Option value={val} key={val}>
              {val}
            </Select.Option>
          ))}
        </Select>
      )}
      {searchQueryType.includes('By Gender') && (
        <Select
          placeholder="Select Gender"
          onChange={(value) => appendSearchForm({ gender: value })}
          allowClear
          onClear={() => appendSearchForm({ gender: '' })}
          className="search-input"
        >
          {GENDER_TYPE.map((val) => (
            <Select.Option value={val} key={val}>
              {val}
            </Select.Option>
          ))}
        </Select>
      )}
      {searchQueryType.includes('By Device Type') && (
        <Select
          placeholder="Select Device Type"
          onChange={(value) => appendSearchForm({ deviceType: value })}
          onClear={() => appendSearchForm({ deviceType: '' })}
          allowClear
          className="search-input"
        >
          {PHONE_MODEL.map(({label,value}) => (
                      <Select.Option value={value} key={value}>
                        {label}
                      </Select.Option>
                    ))}
        </Select>
      )}
      {searchQueryType.includes('By Provider') && (
        <ProviderCountrySelect onChange={handleCountryChange} />
      )}
      {searchQueryType.includes('By Event Date') && (
        <>
          <DatePicker.RangePicker
            bordered={false}
            format="YYYY-MM-DD"
            placeholder={['Start Date', 'End Date']}
            onChange={(dates) => {
              appendSearchForm({
                startDate: dates[0] ? dates[0].format('YYYY-MM-DD') : null,
                endDate: dates[1] ? dates[1].format('YYYY-MM-DD') : null,
              })
            }}
          />
        </>
      )}
       {searchQueryType.includes('By User Type') && (

             <Select
                placeholder="Select User Type"
                onChange={handleFilterChange}
                onClear={() => {
                  
                  appendSearchForm({ userAccessType: '' });
                  
                }}
               
                className="search-input"
              >
                {allUserTypeOptions.map(({ label, value }) => (
                  <Select.Option value={value} key={value}>
                    {label}
                  </Select.Option>
                ))}
              </Select>
            )}

      <Button
        type="primary"
        icon={<SearchOutlined />}
        onClick={handleSearchClick}
        className="search-btn"
      >
        Search
      </Button>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '10px',
        }}
      >
        <FilePdfOutlined
          title="export to pdf"
          style={{ fontSize: '24px', cursor: 'pointer', marginLeft: '10px' }}
          onClick={handlePdfClick}
        />
        <FileExcelOutlined
          title="export to csv"
          style={{ fontSize: '24px', cursor: 'pointer', marginLeft: '10px' }}
          onClick={handleCsvClick}
        />
      </div>
    </>
  )
}

TreasureHunterReportSearch.displayName = 'TreasureHunterReportSearch'
export default TreasureHunterReportSearch
